import { NavigationContainer } from "@react-navigation/native";
import React, { useState, useEffect } from "react";
import { View, Text, StyleSheet, Picker, SafeAreaView, ScrollView, Switch, ActivityIndicator, TouchableOpacity, Modal, Pressable } from "react-native";
import { Button } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Icon from 'react-native-vector-icons/FontAwesome';
import { useTranslation } from 'react-i18next';
import { i18n } from '../assets/lang/i18next';



const BorodatiSimple = (props) => {



    const { t, i18n } = useTranslation();
    const useStyles = makeStyles(() => ({
        textField: {
            width: "100%",
            marginTop: 20,
            marginLeft: "auto",
            marginRight: "auto",
            paddingBottom: 0,
            marginTop: 0,
            fontWeight: 500,
            fontSize: 13,
            direction: i18n.language == "en" ? "ltr" : "rtl",
            "& .MuiFormLabel-root": {
                color: 'black',
                textAlign: i18n.language == "en" ? 'left' : 'right',
                fontFamily: 'IranSans',
                fontSize: 13, direction: i18n.language == "en" ? 'ltr' : 'rtl', width: '100%',
            },
            "& .MuiInputLabel-asterisk": {
                color: '#d12023',
                fontWeight: 900,
            },
            "& .MuiInputBase-input": {
                color: '#333', textAlign: 'center'
            },
            '& label.Mui-focused': {
                color: '#333',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'yellow',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'white',
                },
                '&:hover fieldset': {
                    borderColor: '#06619b',
                },
                '&.Mui-focused fieldset': {
                    borderColor: '#333',
                },
            },

        },
        labelRoot: {
            right: i18n.language == "en" ? 0 : 20,
            left: i18n.language == "en" ? 25 : 0,
        },
        shrink: {
            transformOrigin: i18n.language == "en" ? "top left" : "top right",
        },
        input: {
            color: "black", fontFamily: 'IranSans',
            fontSize: 13,

        },
        btn_calculate: {
            color: '#333',
            backgroundColor: 'gray',
            fontFamily: 'IranSans',
            fontSize: 13, fontWeight: 900,
        }
    }));
    let jamkol = 0;

    const classes = useStyles();

    const [isTempHelpEnabled, setIsTempHelpEnabled] = useState(false);
    const toggleTempHelpSwitch = () => {
        setIsTempHelpEnabled(previousState => !previousState);
    };
    const [selectedMonthValue, setMonthSelectedValue] = useState('');
    const [MSGSardkganeSelected, setMSGSardkganeSelected] = useState('');
    const [selectedCityValue, setCitySelectedValue] = useState('');
    const [itemsCityTemp, setCityTempItems] = useState([]);
    const [itemsEvapTemp, setEvapTempItems] = useState([]);
    const [itemsCondTemp, setCondTempItems] = useState([]);
    const [itemsMobaredTemp, setMobaredTempItems] = useState([]);
    const [datacity, setCityData] = useState(() => { item => setCityData(item) });
    const [dataevap, setEvapData] = useState(() => { item => setEvapData(item) });
    const [datacond, setCondData] = useState(() => { item => setCondData(item) });
    const [datamobared, setMobaredData] = useState(() => { item => setMobaredData(item) });
    const [tempture, setTempture] = useState('0');
    const [inprogsess, setInprogress] = useState(false);
    const [isshowhajmbarvorodi, setIsshowhajmbarvorodi] = useState(false);
    const [selectedsardkhane, setSelectedSardkhane] = useState(0);
    const [txt_tempture, setTxt_Tempture] = useState('');
    const [isshowkarbari, setIsshowkarbari] = useState(false);

    const [txt_tol, setTxtTol] = useState(0);
    const [txt_arz, setTxtArz] = useState(0);
    const [txt_ertefa, setTxtErtefa] = useState(0);
    const [txt_hajmbarvorodi, setHajmbarvorodi] = useState("");
    const [dbdamaytagh, SetDbdamaytagh] = useState('');
    const [dbdamaynahai, SetDbdamaynahai] = useState('');
    const [dbzekhamatdivar, SetDbzekhamatdivar] = useState('');
    const [dbzamansardsazi, SetDbzamansardsazi] = useState('');
    const [dbzaribbargiri, SetDbzaribbargiri] = useState('');
    const [dbdamayvorod, SetDbdamayvorod] = useState('');
    const [dbzarfiyatvijeh, SetDbzarfiyatvijeh] = useState('');
    const [dbafterenjemad, SetDbafterenjemad] = useState('');
    const [dbbeforeenjemad, SetDbbeforeenjemad] = useState('');
    const [dbenjemad, SetDbenjemad] = useState('');
    const [dbtanafosi, SetDbanafosi] = useState('');
    const [dbdeltatcomp, setDbDeltatComp] = useState(0);
    const [anscalculate, setAnsCalculate] = useState('');
    const [karkerdsystem, setZamanKarkerdSystem] = useState(18);
    const [te, SetTe] = useState(0);
    const [tc, SetTc] = useState(0);
    const [brand, setBrand] = useState(0);
    const [mobared, setMobared] = useState(0);
    const [zarfiyatevaprator, setZarfiyatevaprator] = useState(0);
    const [q, setQ] = useState(0);
    const [txttedadevaprator, SetTxtTedadEvaprator] = useState(1);
    const [selectcompanyevaprator, setSelectCompanyEvaprator] = useState(0);
    const [selectcompanycond, setSelectCompanyCond] = useState(0);
    const [zarfiyatnami, setZarfiyatnami] = useState("-");
    const [zarfiyatnamicond, setZarfiyatnamicond] = useState("-");

    const [selectcompresor, setSelectCompresor] = useState("-");


    const [param_zarfiyatbargiri, SetParamZarfiyatBargori] = useState(0);
    let fc = 0;
    let qn_1 = 0;
    let localQN = 0;
    let zarfiyatbargirikol = 0; let zarfiyatbargirirozaneh = 0;
    const [errorlist, SetErrorList] = useState("");


    function mohasebeQN() {
        switch (dbdamaytagh - parseFloat(te)) {
            case 5:
                fc = (0.7109825 + (0.02437231 * (te)) + (0.001258625 * (Math.pow(te, 2))) + (0.00003948019 * (Math.pow(te, 3))) + (0.0000006536131 * (Math.pow(te, 4))) + (0.000000004307692 * (Math.pow(te, 5))));
                break;
            case 6:
                fc = (0.8709434 + (0.03498631 * (te)) + (0.002442587 * (Math.pow(te, 2)) + (0.00009775781 * (Math.pow(te, 3))) + (0.000001914033 * (Math.pow(te, 4))) + (0.00000001421538 * (Math.pow(te, 5)))));
                break;
            case 7:
                fc = (1.050832 + (0.03611483 * (te)) + (0.00191451 * (Math.pow(te, 2))) + (0.0000595303 * (Math.pow(te, 3))) + (0.0000009655012 * (Math.pow(te, 4))) + (0.00000000625641 * (Math.pow(te, 5))));
                break;
            case 8:
                fc = (1.245332 + (0.0481014 * (te)) + (0.003071678 * (Math.pow(te, 2))) + (0.0001145338 * (Math.pow(te, 3))) + (0.00000213986 * (Math.pow(te, 4))) + (0.00000001538462 * (Math.pow(te, 5))));
                break;
            case 9:
                fc = (1.245332 + (0.0481014 * (te)) + (0.003071678 * (Math.pow(te, 2))) + (0.0001145338 * (Math.pow(te, 3))) + (0.00000213986 * (Math.pow(te, 4))) + (0.00000001538462 * (Math.pow(te, 5))));
                break;
            case 10:
                fc = (1.604168 + (0.06317434 * te) + (0.00436317 * (Math.pow(te, 2))) + (0.0001764953 * (Math.pow(te, 3))) + (0.00000357296 * (Math.pow(te, 4))) + (0.00000002758974 * (Math.pow(te, 5))));
                break;
            case 10:
                break;
        }
        qn_1 = parseFloat(zarfiyatevaprator) / parseFloat(parseFloat(txttedadevaprator) * fc);
        if (mobared == "R22") {
            localQN = qn_1;
            return qn_1;
        }
        else
            if (mobared == "R134") { localQN = parseFloat(qn_1) * parseFloat(0.97); return parseFloat(qn_1) * parseFloat(0.97); }
            else
                if (mobared == "R404a/R507a") { localQN = parseFloat(qn_1) * parseFloat(1.05); return parseFloat(qn_1) * parseFloat(1.05); }
    }
    const GetOutTemp = (city, month) => {
        setInprogress(true);
        fetch(`https://app.arshehkar.com/query/public/GetTempByCityMonth.php?city=${city}`)
            .then(response => response.json())
            .then(async (responseJson) => {
                switch (month) {
                    case '1':
                        setTempture(responseJson["tmp_out_m_1"]);
                        break;

                    case '2':
                        setTempture(responseJson["tmp_out_m_2"]);
                        break;

                    case '3':
                        setTempture(responseJson["tmp_out_m_3"]);
                        break;

                    case '4':
                        setTempture(responseJson["tmp_out_m_4"]);
                        break;
                    case '5':
                        setTempture(responseJson["tmp_out_m_5"]);
                        break;
                    case '6':
                        setTempture(responseJson["tmp_out_m_6"]);
                        break;
                    case '7':
                        setTempture(responseJson["tmp_out_m_7"]);
                        break;
                    case '8':
                        setTempture(responseJson["tmp_out_m_8"]);
                        break;
                    case '9':
                        setTempture(responseJson["tmp_out_m_9"]);
                        break;
                    case '10':
                        setTempture(responseJson["tmp_out_m_10"]);
                        break;
                    case '11':
                        setTempture(responseJson["tmp_out_m_11"]);
                        break;
                    case '12':
                        setTempture(responseJson["tmp_out_m_12"]);
                        break;
                    default:
                        setTempture('خطا');

                }
                setInprogress(false);
            })
    }
    function getCities() {

        setInprogress(true);
        fetch('https://app.arshehkar.com/query/public/CityList.php')
            .then(response => response.json())
            .then(async (datacity) => {
                const mapArray = datacity.map(({ title_city, id }) => ({ label: title_city, value: id }));
                setCityTempItems(mapArray);
                setInprogress(false);
            })
    }
    function getCitiesEn() {

        setInprogress(true);
        fetch('https://app.arshehkar.com/query/public/CityList.php')
            .then(response => response.json())
            .then(async (datacity) => {
                const mapArray = datacity.map(({ title_en_city, id }) => ({ label: title_en_city, value: id }));
                setCityTempItems(mapArray);
                setInprogress(false);
            })
    }

    function GetMobared(parambrand, parammobared) {
        setInprogress(true);
        setZarfiyatevaprator("-");
        fetch(`https://app.arshehkar.com/query/public/GetCompList.php?te=${te}&tc=${Math.floor(parseFloat(txt_tempture) + ((parseFloat(-0.24) * parseFloat(txt_tempture)) + 19))}&brand=${parambrand}&model=${parammobared}&q=${q}`)
            .then(response => response.json())
            .then(async (datamobared) => {
                const mapArray = datamobared.map(({ model, ans }) => ({ label: model, value: ans }));
                setMobaredTempItems(mapArray);
                setInprogress(false);
                if (datamobared.length > 0) {
                    setZarfiyatevaprator(datamobared[0]["ans"]);
                    setSelectCompresor(datamobared[0]["model"]);
                }
                else {
                    setZarfiyatevaprator("-");
                    setSelectCompresor("-");
                }
            })
    }
    function GetListEvaprator(selbnd) {
        setInprogress(true);
        fetch(`https://app.arshehkar.com/query/public/GetListEvaprator.php?qn=${localQN}&cmp=${selbnd}&totagh=${dbdamaytagh}`)
            .then(response => response.json())
            .then(async (dataevap) => {
                const mapArray = dataevap.map(({ model_title, zarfiyatnami }) => ({ label: model_title, value: zarfiyatnami }));
                setEvapTempItems(mapArray);
                setInprogress(false);
                if (dataevap.length > 0)
                    setZarfiyatnami(dataevap[0]["zarfiyatnami"])
                else
                    setZarfiyatnami("0")

            })
    }
    function GetCondenser(paramcompanycond) {
        setInprogress(true);
        fetch(`https://app.arshehkar.com/query/public/GetCondList.php?com=${selectcompresor}&cmpany=${paramcompanycond}&tc=${Math.floor(parseFloat(txt_tempture) + ((parseFloat(-0.24) * parseFloat(txt_tempture)) + 19))}&te=${parseFloat(te) >= parseFloat(-20) && parseFloat(te) <= parseFloat(-5) ? parseFloat(-5) : (parseFloat(te) >= parseFloat(-35) && parseFloat(te) < parseFloat(-20)) ? parseFloat(-20) : parseFloat(te) < parseFloat(-35) && parseFloat(te) > parseFloat(-45) ? parseFloat(-25) : parseFloat(te) > parseFloat(-5) ? parseFloat(te) : "-"}&model=${mobared}&zevap=${zarfiyatevaprator}&otmp=${txt_tempture}&brandcom=${brand}`)
            .then(response => response.json())
            .then(async (datacond) => {
                const mapArray = datacond.map(({ model_title, zarfiyatnami }) => ({ label: model_title, value: zarfiyatnami }));
                setCondTempItems(mapArray);
                setInprogress(false);
                if (datacond.length > 0)
                    setZarfiyatnamicond(datacond[0]["zarfiyatnami"]);
                else
                    setZarfiyatnamicond('-');

            })

    }
    const GetFinalTemp = (idprdt) => {
        if (idprdt != 0) {
            setInprogress(true);
            fetch(`https://app.arshehkar.com/query/public/GetDataSimpleCal.php?id=${idprdt}`)
                .then(response => response.json())
                .then(async (responseJsontmp) => {
                    SetDbdamaytagh(responseJsontmp["temproom"]);
                    SetDbdamaynahai(responseJsontmp["finaltemp"]);
                    SetDbzekhamatdivar(responseJsontmp["zekhamatdivarsaghf"]);
                    SetDbzamansardsazi(responseJsontmp["zamansardsazi"]);
                    SetDbzaribbargiri(responseJsontmp["zaribbargiri"]);
                    SetDbdamayvorod(responseJsontmp["damayvorodmahsol"]);
                    SetDbzarfiyatvijeh(responseJsontmp["zarfiyatgarmaeivijeh"]);
                    SetDbafterenjemad(responseJsontmp["zarfiyatafter"]);
                    SetDbbeforeenjemad(responseJsontmp["zarfiyatbefore"]);
                    SetDbenjemad(responseJsontmp["damayenjemad"]);
                    SetDbanafosi(responseJsontmp["zaribtanafos"]);
                    setDbDeltatComp(responseJsontmp["deltatcomp"]);
                    SetTe(((parseFloat(responseJsontmp["temproom"]) - parseFloat(responseJsontmp["deltatcomp"])) < parseFloat("-45") && (parseFloat(responseJsontmp["temproom"]) - parseFloat(responseJsontmp["deltatcomp"])) > parseFloat("-48")) ? "-45" : (parseFloat(responseJsontmp["temproom"]) - parseFloat(responseJsontmp["deltatcomp"])));
                    setInprogress(false);
                })

        } else {
            SetErrorList(t('selectyourcoldroomapplication'));
            setModalVisible(true);
        }
    }
    let jedareha = 0, tavizhava = 0, hararatyi = 0, sardsazi = 0, tanafosi = 0, qtransfer = 0, tctransfer = 0;
    const FuncTalafatHararati = () => {


        jedareha = (((0.36 * (txt_tol * txt_arz) * ((parseFloat(txt_tempture) <= 0 ? (parseFloat(27.0373) + ((parseFloat(0.3955711) * parseFloat(dbdamaytagh))) - (parseFloat(0.01156177) * (Math.pow(dbdamaytagh, 2))) - (parseFloat(0.0004475524) * (Math.pow(dbdamaytagh, 3))) - (parseFloat(0.000005594406) * (Math.pow(dbdamaytagh, 4)))) - parseFloat(dbdamaytagh) : (parseFloat(txt_tempture) - parseFloat(dbdamaytagh))))) / 1000)
            +
            ((((0.018 * 1000) / parseFloat(dbzekhamatdivar)) * ((txt_tol * txt_ertefa * 2) + (txt_tol * txt_arz) + (txt_ertefa * txt_arz * 2)) * (parseFloat(txt_tempture) - parseFloat(dbdamaytagh))) / 1000)).toFixed(3)
        if (jedareha != "خطا" && jedareha != "")
            jamkol = parseFloat(jamkol) + parseFloat(jedareha);

        let hajm = (txt_tol * txt_arz * txt_ertefa);
        let deltat = txt_tempture - dbdamaytagh;

        tavizhava = (parseFloat(hajm) <= 43.5) ?
            ((((0.7 * hajm) + 2) * deltat) / 1000)
            :
            (parseFloat(hajm) > 43.5 && hajm < 600) ?
                ((((0.125 * hajm) + 27) * deltat) / 1000)
                :
                (parseFloat(hajm) >= 600) ?
                    ((((0.04 * hajm) + 78) * deltat) / 1000)
                    :
                    "خطا";
        if (tavizhava != "خطا" && tavizhava != "")
            jamkol = parseFloat(jamkol) + parseFloat(tavizhava);

        let tavanfan = ((250 * 20) / 24);
        let roshanaei = ((15 * 8 * txt_tol * txt_arz) / 24);
        let kargar = (((0.2736364 - (0.006514719 * dbdamaytagh) + (0.00006030303 * Math.pow(dbdamaytagh, 2)) - (0.000001454545 * Math.pow(dbdamaytagh, 3)) - (0.0000002060606 * Math.pow(dbdamaytagh, 4))) * 2 * 8) / dbzamansardsazi) * 1000;

        hararatyi = ((parseFloat(tavanfan) + parseFloat(roshanaei) + parseFloat(kargar)) / 1000).toFixed(3);
        if (hararatyi != "خطا" && hararatyi != "")
            jamkol = parseFloat(jamkol) + parseFloat(hararatyi);



        (selectedsardkhane === "5" || selectedsardkhane === "6") ?
            zarfiyatbargirikol = txt_hajmbarvorodi
            :
            zarfiyatbargirikol = Math.round((txt_tol * txt_arz * txt_ertefa * 1000) / parseFloat(dbzaribbargiri));


        (selectedsardkhane === "5" || selectedsardkhane === "6") ?
            zarfiyatbargirirozaneh = txt_hajmbarvorodi
            :
            zarfiyatbargirirozaneh = (parseFloat(zarfiyatbargirikol) < parseFloat(150000)) ?
                (Math.round(zarfiyatbargirikol * 0.1))
                : (parseFloat(zarfiyatbargirikol) >= parseFloat(150000) && parseFloat(zarfiyatbargirikol) < parseFloat(250000)) ?
                    15000
                    : (parseFloat(zarfiyatbargirikol) >= parseFloat(250000) && parseFloat(zarfiyatbargirikol) < parseFloat(350000)) ?
                        17500
                        : (parseFloat(zarfiyatbargirikol) >= 350000 && parseFloat(zarfiyatbargirikol) < 450000) ?
                            20000
                            : (parseFloat(zarfiyatbargirikol) >= parseFloat(450000) && parseFloat(zarfiyatbargirikol) < parseFloat(550000)) ?
                                25000
                                : (parseFloat(zarfiyatbargirikol) >= parseFloat(550000)) ?
                                    (Math.round(parseFloat(zarfiyatbargirikol) * 0.05)) :
                                    "خطا";


        sardsazi = (parseFloat(dbdamaynahai) >= parseFloat(dbenjemad)) ?
            (((zarfiyatbargirirozaneh * dbbeforeenjemad * (dbdamayvorod - (parseFloat(dbdamaynahai) > parseFloat(dbenjemad) ? dbdamaynahai : dbenjemad))) / (3600 * dbzamansardsazi))).toFixed(3)
            :
            ((parseFloat(dbenjemad) > parseFloat(dbdamaynahai)) && (parseFloat(dbdamayvorod) > parseFloat(dbenjemad))) ?
                ((((zarfiyatbargirirozaneh * dbzarfiyatvijeh) / (3600 * dbzamansardsazi)) +
                    ((zarfiyatbargirirozaneh * dbbeforeenjemad * (dbdamayvorod - (parseFloat(dbdamaynahai) > parseFloat(dbenjemad) ? dbdamaynahai : dbenjemad))) / (3600 * dbzamansardsazi))
                    + ((zarfiyatbargirirozaneh * dbafterenjemad * ((parseFloat(dbenjemad) > parseFloat(dbdamayvorod) && parseFloat(dbenjemad) > parseFloat(dbdamaynahai) ? dbdamayvorod : dbenjemad) - dbdamaynahai)) / (3600 * dbzamansardsazi))
                )).toFixed(3)
                :
                ((parseFloat(dbenjemad) > parseFloat(dbdamaynahai)) && (parseFloat(dbenjemad) >= parseFloat(dbdamayvorod))) ?
                    (
                        (((zarfiyatbargirirozaneh * dbafterenjemad * ((((parseFloat(dbenjemad) > parseFloat(dbdamayvorod)) && (parseFloat(dbenjemad) > parseFloat(dbdamaynahai))) ? dbdamayvorod : dbenjemad) - dbdamaynahai)) / (3600 * dbzamansardsazi))).toFixed(3)
                    )
                    : (dbenjemad == "" || dbenjemad == null) ?
                        (((zarfiyatbargirirozaneh * dbafterenjemad * (dbdamayvorod - (parseFloat(dbdamaynahai) > parseFloat(dbenjemad) ? dbdamaynahai : dbenjemad))) / (3600 * dbzamansardsazi))).toFixed(3)
                        :
                        "خطا";
        if (sardsazi != "خطا" && sardsazi != "")
            jamkol = parseFloat(jamkol) + parseFloat(sardsazi);

        if (selectedsardkhane === "4") {
            let zarfiyatbargirikol = 0;
            (selectedsardkhane === "5" || selectedsardkhane === "6") ?
                zarfiyatbargirikol = txt_hajmbarvorodi
                :
                zarfiyatbargirikol = Math.round((txt_tol * txt_arz * txt_ertefa * 1000) / parseFloat(dbzaribbargiri));

            tanafosi = (parseFloat(dbdamaynahai) <= parseFloat(dbenjemad)) ? "0" :
                ((zarfiyatbargirikol * parseFloat(dbtanafosi)) / (dbzamansardsazi * 3600)).toFixed(3);
            if (tanafosi != "خطا" && tanafosi != "")
                jamkol = parseFloat(jamkol) + parseFloat(tanafosi);
        }
        else
            SetParam_tanafosi(0);
        qtransfer = ((jamkol * 24) / karkerdsystem).toFixed(2);
        setQ(qtransfer);
        tctransfer = Math.floor(parseFloat(txt_tempture) + ((parseFloat(-0.24) * parseFloat(txt_tempture)) + 19));
        SetTc(Math.floor(parseFloat(txt_tempture) + ((parseFloat(-0.24) * parseFloat(txt_tempture)) + 19)));

    }
    const [param_mabaghihararati, SetParam_mabaghihararati] = useState(0);
    const FuncTalafatMabaghi = () => {
        let tavanfan = ((250 * 20) / dbzamansardsazi);
        let roshanaei = ((15 * 8 * txt_tol * txt_arz) / 24);
        let kargar = (((0.2736364 - (0.006514719 * dbdamaytagh) + (0.00006030303 * Math.pow(dbdamaytagh, 2)) - (0.000001454545 * Math.pow(dbdamaytagh, 3)) - (0.0000002060606 * Math.pow(dbdamaytagh, 4))) * 2 * 8) / dbzamansardsazi);

        const hararatyi = ((parseFloat(tavanfan) + parseFloat(roshanaei) + parseFloat(kargar)) / 1000).toFixed(2);
        if (hararatyi != "خطا" && hararatyi != "")
            jamkol = parseFloat(jamkol) + parseFloat(hararatyi);
        SetParam_mabaghihararati(hararatyi);
        return hararatyi;

    }
    const [param_barsardsazi, SetParam_barsardsazi] = useState(0);
    const FuncSardsazi = () => {

        (selectedsardkhane === "5" || selectedsardkhane === "6") ?
            zarfiyatbargirikol = txt_hajmbarvorodi
            :
            zarfiyatbargirikol = Math.round((txt_tol * txt_arz * txt_ertefa * 1000) / parseFloat(dbzaribbargiri));

        SetParamZarfiyatBargori(zarfiyatbargirikol);

        (selectedsardkhane === "5" || selectedsardkhane === "6") ?
            zarfiyatbargirirozaneh = txt_hajmbarvorodi
            :
            zarfiyatbargirirozaneh = (parseFloat(zarfiyatbargirikol) < parseFloat(150000)) ?
                (Math.round(zarfiyatbargirikol * 0.1))
                : (parseFloat(zarfiyatbargirikol) >= parseFloat(150000) && parseFloat(zarfiyatbargirikol) < parseFloat(250000)) ?
                    15000
                    : (parseFloat(zarfiyatbargirikol) >= parseFloat(250000) && parseFloat(zarfiyatbargirikol) < parseFloat(350000)) ?
                        17500
                        : (parseFloat(zarfiyatbargirikol) >= 350000 && parseFloat(zarfiyatbargirikol) < 450000) ?
                            20000
                            : (parseFloat(zarfiyatbargirikol) >= parseFloat(450000) && parseFloat(zarfiyatbargirikol) < parseFloat(550000)) ?
                                25000
                                : (parseFloat(zarfiyatbargirikol) >= parseFloat(550000)) ?
                                    (Math.round(parseFloat(zarfiyatbargirikol) * 0.05)) :
                                    "خطا";


        const sardsazi = (parseFloat(dbdamaynahai) >= parseFloat(dbenjemad)) ?
            (((zarfiyatbargirirozaneh * dbbeforeenjemad * (dbdamayvorod - (parseFloat(dbdamaynahai) > parseFloat(dbenjemad) ? dbdamaynahai : dbenjemad))) / (3600 * dbzamansardsazi))).toFixed(2)
            :
            ((parseFloat(dbenjemad) > parseFloat(dbdamaynahai)) && (parseFloat(dbdamayvorod) > parseFloat(dbenjemad))) ?
                ((((zarfiyatbargirirozaneh * dbzarfiyatvijeh) / (3600 * dbzamansardsazi)) +
                    ((zarfiyatbargirirozaneh * dbbeforeenjemad * (dbdamayvorod - (parseFloat(dbdamaynahai) > parseFloat(dbenjemad) ? dbdamaynahai : dbenjemad))) / (3600 * dbzamansardsazi))
                    + ((zarfiyatbargirirozaneh * dbafterenjemad * ((parseFloat(dbenjemad) > parseFloat(dbdamayvorod) && parseFloat(dbenjemad) > parseFloat(dbdamaynahai) ? dbdamayvorod : dbenjemad) - dbdamaynahai)) / (3600 * dbzamansardsazi))
                )).toFixed(2)
                :
                ((parseFloat(dbenjemad) > parseFloat(dbdamaynahai)) && (parseFloat(dbenjemad) >= parseFloat(dbdamayvorod))) ?
                    (
                        (((zarfiyatbargirirozaneh * dbafterenjemad * ((((parseFloat(dbenjemad) > parseFloat(dbdamayvorod)) && (parseFloat(dbenjemad) > parseFloat(dbdamaynahai))) ? dbdamayvorod : dbenjemad) - dbdamaynahai)) / (3600 * dbzamansardsazi))).toFixed(2)
                    )
                    : (dbenjemad == "" || dbenjemad == null) ?
                        (((zarfiyatbargirirozaneh * dbafterenjemad * (dbdamayvorod - (parseFloat(dbdamaynahai) > parseFloat(dbenjemad) ? dbdamaynahai : dbenjemad))) / (3600 * dbzamansardsazi))).toFixed(2)
                        :
                        "خطا";
        if (sardsazi != "خطا" && sardsazi != "")
            jamkol = parseFloat(jamkol) + parseFloat(sardsazi);
        SetParam_barsardsazi(sardsazi);
        return sardsazi;
    }
    const [param_tanafosi, SetParam_tanafosi] = useState(0);
    const FuncTanafosi = () => {

        if (selectedsardkhane === "4") {
            let zarfiyatbargirikol = 0;
            (selectedsardkhane === "5" || selectedsardkhane === "6") ?
                zarfiyatbargirikol = txt_hajmbarvorodi
                :
                zarfiyatbargirikol = Math.round((txt_tol * txt_arz * txt_ertefa * 1000) / parseFloat(dbzaribbargiri));

            const tanafosi = (parseFloat(dbdamaynahai) <= parseFloat(dbenjemad)) ? "0" :
                ((zarfiyatbargirikol * parseFloat(dbtanafosi)) / (dbzamansardsazi * 3600)).toFixed(2);
            if (tanafosi != "خطا" && tanafosi != "")
                jamkol = parseFloat(jamkol) + parseFloat(tanafosi);
            SetParam_tanafosi(tanafosi);
            return tanafosi;
        }
        else
            return 0;


    }
    const [param_talafathava, SetParam_talafathava] = useState(0);
    const FuncTalafatHava = () => {
        let hajm = (txt_tol * txt_arz * txt_ertefa);
        let deltat = txt_tempture - dbdamaytagh;

        const tavizhava = (parseFloat(hajm) <= 43.5) ?
            ((((0.7 * hajm) + 2) * deltat) / 1000)
            :
            (parseFloat(hajm) > 43.5 && hajm < 600) ?
                ((((0.125 * hajm) + 27) * deltat) / 1000)
                :
                (parseFloat(hajm) >= 600) ?
                    ((((0.04 * hajm) + 78) * deltat) / 1000)
                    :
                    "خطا";
        if (tavizhava != "خطا" && tavizhava != "")
            jamkol = parseFloat(jamkol) + parseFloat(tavizhava);
        SetParam_talafathava(tavizhava);
        return tavizhava;
    }

    const [modalVisible, setModalVisible] = useState(false);


    React.useEffect(() => {
        if (i18n.language == "en")
            getCitiesEn();
        else
            getCities();



    }, [i18n.language]);
    return (

        <ScrollView>
            <SafeAreaView style={styles.container}>
                {inprogsess === true ?
                    <View style={styles.spinner}>
                        <ActivityIndicator size={90} color='#d12023' />
                    </View>
                    : null}
                <View style={styles.centeredView}>
                    <Modal
                        animationType="slide"
                        transparent={true}
                        visible={modalVisible}
                        onRequestClose={() => {
                            Alert.alert("Modal has been closed.");
                            setModalVisible(!modalVisible);
                        }}
                    >
                        <View style={styles.centeredView}>
                            <View style={styles.modalView}>
                                <View style={[{ flexDirection: 'row', alignItems: 'center' }]}>
                                    <View
                                        style={{
                                            borderBottomWidth: 1,
                                            borderBottomColor: '#d12023',
                                            width: 100, flex: 1, height: 2
                                        }}
                                    />
                                    <View>
                                        <Text style={[styles.textStyle, { width: 50, textAlign: 'center', color: "#000" }]}>{t('error')}</Text>
                                    </View>
                                    <View
                                        style={{
                                            borderBottomWidth: 1,
                                            borderBottomColor: '#d12023',
                                            width: 100, flex: 1, height: 2
                                        }}
                                    />
                                </View>
                                <Text style={styles.modalText}>{errorlist}</Text>
                                <TouchableOpacity
                                    style={[styles.button, styles.buttonClose]}
                                    onPress={() => setModalVisible(!modalVisible)}
                                >
                                    <Text style={styles.textStyle}> {t('ok')} </Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </Modal>
                </View>
                <Text style={{ fontFamily: 'IranSans', fontWeight: 900, fontSize: 14, marginTop: 10, marginBottom: 10 }}>{t('coldroomcalculation(simpleform)')}</Text>
                <View style={styles.form}>
                    <Text style={styles.titleform}>{t('selectyourcoldroomapplication')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setSelectedSardkhane(itemValue);
                            switch (itemValue) {
                                case '0':
                                    setIsshowkarbari(false);
                                    break;
                                case '1':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        setIsshowhajmbarvorodi(false);
                                        return (
                                            <View>
                                                <Text>{'\u2022'} {t('Frozengroceriessuchasmeatpoultryfishgoudacheesebutteretc')}</Text>
                                                <Text>{'\u2022'} {t('Enteringtemperature-5℃')}</Text>
                                                <Text>{'\u2022'} {t('Finaltemperature-18℃')}</Text>
                                                <Text>{'\u2022'} {t('Coolingdowntime8hours')}</Text>
                                            </View>
                                        )
                                    });
                                    setZamanKarkerdSystem(18);
                                    break;

                                case '2':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        setIsshowhajmbarvorodi(false);
                                        return (
                                            <View>
                                                <Text>{'\u2022'} {t('Refrigerationgroceriessuchasdairyproductsdrinksmedicineetc')}</Text>
                                                <Text>{'\u2022'} {t('Enteringtemperature20℃')}</Text>
                                                <Text>{'\u2022'} {t('Finaltemperature0℃')}</Text>
                                                <Text>{'\u2022'} {t('Coolingdowntime8hours')}</Text>
                                            </View>
                                        )
                                    });
                                    setZamanKarkerdSystem(18);
                                    break;

                                case '3':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        setIsshowhajmbarvorodi(false);
                                        return (
                                            <View>
                                                <Text>{'\u2022'} {t('Enteringtemperature-15℃')}</Text>
                                                <Text>{'\u2022'} {t('Finaltemperature-25℃')}</Text>
                                                <Text>{'\u2022'} {t('Coolingdowntime6hours')}</Text>
                                            </View>
                                        )
                                    });
                                    setZamanKarkerdSystem(18);
                                    break;

                                case '4':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        setIsshowhajmbarvorodi(false);
                                        return (
                                            <View>
                                                <Text>{'\u2022'} {t('Productswithrespirationload')}</Text>
                                                <Text>{'\u2022'} {t('Enteringtemperature25℃')}</Text>
                                                <Text>{'\u2022'} {t('Finaltemperature0℃')}</Text>
                                                <Text>{'\u2022'} {t('Coolingdowntime18hours')}</Text>

                                            </View>
                                        )
                                    });
                                    setZamanKarkerdSystem(18);
                                    break;
                                case '5':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        setIsshowhajmbarvorodi(true);
                                        return (
                                            <View>
                                                <Text>{'\u2022'} {t('Proteinproducts')}</Text>
                                                <Text>{'\u2022'} {t('Enteringtemperature5℃')}</Text>
                                                <Text>{'\u2022'} {t('Finaltemperature-40℃')}</Text>
                                                <Text>{'\u2022'} {t('Coolingdowntime8hours')}</Text>

                                            </View>
                                        )
                                    });
                                    setZamanKarkerdSystem(24);
                                    break;
                                case '6':
                                    setMSGSardkganeSelected(() => {
                                        setIsshowkarbari(true);
                                        setIsshowhajmbarvorodi(true);
                                        return (
                                            <View>
                                                <Text>{'\u2022'} {t('Proteinproducts')}</Text>
                                                <Text>{'\u2022'} {t('Enteringtemperature35℃')}</Text>
                                                <Text>{'\u2022'} {t('Finaltemperature0℃')}</Text>
                                                <Text>{'\u2022'} {t('Coolingdowntime4hours')}</Text>

                                            </View>
                                        )
                                    });
                                    setZamanKarkerdSystem(18);
                                    break;
                                default:
                                    setTempture(t('selectyourcoldroomapplication'));
                                    setIsshowkarbari(true);

                            }
                            GetFinalTemp(itemValue);

                        }}
                    >
                        <Picker.Item label={t('select')} value="0" />
                        <Picker.Item label={t('below-zerocoldroom')} value="1" />
                        <Picker.Item label={t('above-zerocoldroom')} value="2" />
                        <Picker.Item label={t('icecreamstorage')} value="3" />
                        <Picker.Item label={t('fruitstorage')} value="4" />
                        <Picker.Item label={t('blastfreezer')} value="5" />
                        <Picker.Item label={t('chilingstorage')} value="6" />
                    </Picker>
                    {isshowkarbari === true ?
                        <Text style={{ padding: 7, color: '#06619b', fontSize: 12, fontFamily: 'IranSans', backgroundColor: '#d6d6d6', marginLeft: '10%', marginRight: '10%', borderRadius: 6, marginBottom: 7 }}>
                            {MSGSardkganeSelected}
                        </Text>
                        : null}
                    <TextField
                        label={t('outsidetemperature')}
                        variant="filled"
                        placeholder={t('entertempratureouts')}
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => setTxt_Tempture(e.target.value)}
                        value={txt_tempture}
                        onFocus={(e) => e.target.select()}
                        onWheel={(e) => e.target.blur()}
                    />
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', margin: 15 }}>
                        <Switch
                            trackColor={{ false: "#767577", true: "#81b0ff" }}
                            thumbColor={isTempHelpEnabled ? "#f5dd4b" : "#f4f3f4"}
                            ios_backgroundColor="#3e3e3e"
                            onValueChange={toggleTempHelpSwitch}
                            value={isTempHelpEnabled}
                        />
                        <Text style={{ fontFamily: 'IranSans', fontSize: 11, color: '#06619b' }} >{t('citytemperatureguide')}</Text>
                    </View>
                    {isTempHelpEnabled === true ?
                        <View>
                            <View style={{ flex: 1, flexDirection: "row-reverse", justifyContent: 'space-between' }}>
                                <View style={{ flex: 1, width: '50%', marginLeft: 5 }}>
                                    <Text style={styles.titleform}>{t('cityselect')}</Text>
                                    <Picker
                                        style={styles.dropdown}
                                        selectedValue={datacity}
                                        onValueChange={(itemValue, itemIndex) => {
                                            setCitySelectedValue(itemValue);
                                            GetOutTemp(itemValue, selectedMonthValue);
                                        }}
                                    >
                                        <Picker.Item label={t('select')} value="0" />
                                        {itemsCityTemp.map((item, index) => {
                                            return (
                                                <Picker.Item
                                                    key={index}
                                                    label={item.label}
                                                    value={item.value}
                                                />
                                            )
                                        }
                                        )
                                        }
                                    </Picker>
                                </View>
                                <View style={{ flex: 1, width: '50%' }}>
                                    <Text style={styles.titleform}>{t('monthselect')}</Text>
                                    <Picker
                                        style={styles.dropdown}
                                        onValueChange={(itemValue, itemIndex) => {
                                            setMonthSelectedValue(itemValue);
                                            GetOutTemp(selectedCityValue, itemValue);
                                        }}
                                    >
                                        <Picker.Item label={t('select')} value="0" />
                                        <Picker.Item label={t('Month1')} value="1" />
                                        <Picker.Item label={t('Month2')} value="2" />
                                        <Picker.Item label={t('Month3')} value="3" />
                                        <Picker.Item label={t('Month4')} value="4" />
                                        <Picker.Item label={t('Month5')} value="5" />
                                        <Picker.Item label={t('Month6')} value="6" />
                                        <Picker.Item label={t('Month7')} value="7" />
                                        <Picker.Item label={t('Month8')} value="8" />
                                        <Picker.Item label={t('Month9')} value="9" />
                                        <Picker.Item label={t('Month10')} value="10" />
                                        <Picker.Item label={t('Month11')} value="11" />
                                        <Picker.Item label={t('Month12')} value="12" />
                                    </Picker>
                                </View>
                            </View>
                            <View>
                                <Text style={{ fontFamily: 'IranSans', textAlign: 'center', fontWeight: 900, padding: 10, color: '#d12023', fontSize: 13 }}
                                    onPress={(e) => { setTxt_Tempture(tempture) }}
                                >
                                    {t('temperaturemaximum')} :  {tempture} {t('darajehc')}
                                </Text>
                            </View>
                        </View>
                        : null}
                    <TextField label={t('length')}
                        variant="filled"
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => setTxtTol(e.target.value)}
                        value={txt_tol}
                        onFocus={(e) => e.target.select()}
                        onWheel={(e) => e.target.blur()}
                    />
                    <TextField label={t('width')}
                        variant="filled"
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => setTxtArz(e.target.value)}
                        value={txt_arz}
                        onFocus={(e) => e.target.select()}
                        onWheel={(e) => e.target.blur()}
                    />
                    <TextField label={t('height')}
                        variant="filled"
                        type="number"
                        className={classes.textField}
                        required
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => setTxtErtefa(e.target.value)}
                        value={txt_ertefa}
                        onFocus={(e) => e.target.select()}
                        onWheel={(e) => e.target.blur()}
                    />
                    <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
                        <Text style={{ fontFamily: 'IranSans', textAlign: 'center', fontWeight: 900, padding: 10, color: '#d12023', fontSize: 13 }}>
                            {t('volume')} : {txt_tol * txt_arz * txt_ertefa} {t('cubicmeter')}
                        </Text>
                    </View>
                    {isshowhajmbarvorodi == true ?
                        <TextField label={t('entringvolume')}
                            variant="filled"
                            type="number"
                            className={classes.textField}
                            required
                            InputProps={{
                                className: classes.input
                            }}
                            InputLabelProps={{
                                classes: { root: classes.labelRoot, shrink: classes.shrink }
                            }}
                            margin="normal"
                            onChange={(e) => setHajmbarvorodi(e.target.value)}
                            value={txt_hajmbarvorodi}
                            onWheel={(e) => e.target.blur()}
                        />
                        : null}
                    <TouchableOpacity style={styles.touchable}
                        onPress={() => {
                            let MSGERROR = "";
                            if (selectedsardkhane === 0)
                                MSGERROR += t('selectyourcoldroomapplication') + "\n";
                            if (parseFloat(dbdamaytagh) < parseFloat("-50") || parseFloat(dbdamaytagh) > parseFloat("20"))
                                MSGERROR += t('Theroomtemperatureshouldbebetween-50and20degreesCelsius') + "\n";
                            if (parseFloat(txt_tempture) < parseFloat("-20") || parseFloat(txt_tempture) > parseFloat("60"))
                                MSGERROR += t('Theoutsidetemperatureshouldbebetween-20and60degreesCelsius') + "\n";
                            if (parseFloat(txt_tempture) < parseFloat(dbdamaytagh))
                                MSGERROR += t('Theoutsidetemperatureshouldnotbelowerthantheroomtemperature') + "\n";
                            if (parseFloat(txt_tol) <= 0 || parseFloat(txt_arz) <= 0 || parseFloat(txt_ertefa) <= 0)
                                MSGERROR += t('Dimensions(length,width,height)mustbegreaterthan0') + "\n";
                            if (txt_tempture == "")
                                MSGERROR += t('Enteroutsidetemperature') + "\n";
                            if ((selectedsardkhane == "5" || selectedsardkhane == "6") && txt_hajmbarvorodi == "")
                                MSGERROR += t('entertheentranceloadvolume') + "\n";
                            if (txt_tol == "" || txt_arz == "" || txt_ertefa== "")
                                MSGERROR += t('Dimensions(length,width,height)EnterCorrect') + "\n";

                            if (MSGERROR === "") {
                                FuncTalafatHararati();
                                props.navigation.navigate('BorodatiResult', {
                                    DAMAYOTAGH: dbdamaytagh, DAMAYOUT: txt_tempture, SHEDAT: '1', ZAMANSYSTEM: karkerdsystem, TOL: txt_tol, ARZ: txt_arz, ERTEFA: txt_ertefa, AYEGH: t('polyurethane'), ZEKHAMATDIVAR: dbzekhamatdivar, ZEKHAMATKAF: 50, ZARIBHADAYATAYEGH: 0.018, TAVANFAN: "250/20", ROSHANAIE: "15/8", TEDADKARGAR: "2/8", LIFTRAG: "0/0", ZARFIYATBARGIRI: zarfiyatbargirikol, DAMAYVORODI: dbdamayvorod, ZAMANSARDSAZI: dbzamansardsazi, KARBARIID: selectedsardkhane, KARBARI: (selectedsardkhane == 1 ? t('Generalmeat') : selectedsardkhane == 2 ? t('dairy') : selectedsardkhane == 3 ? t('Icecream') : selectedsardkhane == 4 ? t('Fruit') : selectedsardkhane == 5 ? t('Protein') : selectedsardkhane == 6 ? t('Protein') : null)
                                    , TALAFATJEDAREHA: jedareha, TALAFATHAVA: tavizhava, MABAGHIHARARATI: hararatyi,
                                    BARSARDSAZI: sardsazi, BARTANAFOSI: tanafosi, QN: qtransfer, TE: te, TC: tctransfer
                                })
                            }
                            else {
                                SetErrorList(MSGERROR);
                                setModalVisible(true);
                            };
                        }}>

                        <Text style={styles.titlebutton}>{t('calculatecoolingload')}</Text>
                        <Icon name={"calculator"} color="#fff" size={20} />
                    </TouchableOpacity>

                </View>

            </SafeAreaView>
        </ScrollView>

    )
}

export default BorodatiSimple;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#ebecec'
    }
    ,
    titleform: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
    }
    ,
    inputtext: {
        backgroundColor: '#fff',
        textAlign: 'center',
        borderColor: "gray",
        width: "100%",
        borderWidth: 1,
        borderRadius: 10,
        padding: 10, width: '100%', height: 30
    }
    ,
    dropdown: {
        height: 50,
        width: '100%',
        marginBottom: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
        borderWidth: 0,
        textAlign: 'center',
        backgroundColor: '#c9c9c9',
        direction: 'rtl',


    },
    form: {
        width: '90%',
        backgroundColor: '#ddd',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3
    }
    ,
    touchable: {
        backgroundColor: '#022a4c', color: 'white', padding: 15, margin: 15, borderRadius: 4, flexDirection: "row",
        justifyContent: "center",
        alignItems: "center"
    },
    titlebutton: {

        fontSize: 14,
        lineHeight: 21,
        fontWeight: 'normal',
        fontFamily: 'IranSans',
        letterSpacing: 0.25,
        color: 'white',
        textAlign: 'center', marginRight: 20,

    },
    spinner: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'black',
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9000,
        opacity: 0.5,
    }
    ,
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        marginTop: 10
    },
    modalView: {
        margin: 10,
        backgroundColor: "white",
        borderRadius: 20,
        padding: 15,
        width: '75%',
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5
    },
    button: {
        borderRadius: 20,
        padding: 10,
        elevation: 2
    },
    buttonOpen: {
        backgroundColor: "#F194FF",
    },
    buttonClose: {
        backgroundColor: "#06619b",
    },
    textStyle: {
        color: "white",
        fontWeight: 600,
        textAlign: "center",
        fontFamily: 'IranSans',
        fontSize: 14.1

    },
    modalText: {
        marginBottom: 10,
        textAlign: "center", fontFamily: 'IranSans', fontSize: 13.5,
    }
});
